/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Pbinc2Inputs */

const ja_company_companydetails_pbinc2 = /** @type {(inputs: Company_Companydetails_Pbinc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN Inc.`)
};

const en_company_companydetails_pbinc2 = /** @type {(inputs: Company_Companydetails_Pbinc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN Inc.`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN Inc." |
*
* @param {Company_Companydetails_Pbinc2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_pbinc2 = /** @type {((inputs?: Company_Companydetails_Pbinc2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Pbinc2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_pbinc2(inputs)
	return en_company_companydetails_pbinc2(inputs)
});
export { company_companydetails_pbinc2 as "company_companyDetails_pbInc" }